import React from 'react'
import './Footer.scss'
import Logo from '../Logo'
import FooterElement from './FooterElement'

import linkedinImg from 'src/assets/images/instagram.png'
import { COMPANY_LINKEDIN_URL } from 'src/constans'

import { useTranslation } from 'react-i18next';

const Footer = () => {
    const { t } = useTranslation();

    return (
        <div className="Footer">
            <div className="Footer__Top">
                <div className="Footer__LogoAndLinksWrapper">
                    <Logo to={undefined} animated={false} className="" dark={false} />
                    <div className="Footer__Links">
                        <FooterElement className="Footer__Links__Element" to="#main" active={false}>{t('Home')}</FooterElement>
                        <FooterElement className="Footer__Links__Element" to="#about-us" active={false}>{t('About us')}</FooterElement>
                        <FooterElement className="Footer__Links__Element" to="#mission" active={false}>{t('Our Mission')}</FooterElement>
                        <FooterElement className="Footer__Links__Element" to="#products" active={false}>{t('Products')}</FooterElement>
                        <FooterElement className="Footer__Links__Element" to="#customers" active={false}>{t('Customers')}</FooterElement>
                        <FooterElement className="Footer__Links__Element" to="#contact" active={false}>{t('Contact us')}</FooterElement>
                    </div>
                </div>

                <div className="Footer__Socials">
                    <a href={COMPANY_LINKEDIN_URL}>
                        <img src={linkedinImg} alt="Apriside company's logo" />
                    </a>
                </div>
            </div>

            <div className="Footer__Copyright">
                © 2019 apriside.com All Rights Reserved.
            </div>
        </div>
    )
}

export default Footer
